import { render, staticRenderFns } from "./DocumentTypesView.vue?vue&type=template&id=0d052e26"
import script from "./DocumentTypesView.vue?vue&type=script&lang=js"
export * from "./DocumentTypesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports